module.exports = __webpack_public_path__ + "static/media/t&c.a95d2ea4.svg";